/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'
import { Record } from 'immutable'
import PaginationParams from '../PagenationParams'

const AccommodationInvoicePaginationState = Record(PaginationParams)

class AccommodationInvoicePaginationStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AccommodationInvoicePaginationState()
  }

  reduce(state, action) {
    const pagination = action.payload.pagination

    switch (action.type) {
      case AccommodationInvoiceEvent.initialize:
        return state.clear()
      case AccommodationInvoiceEvent.onSearch:
        return state.merge({
          page: pagination.page,
          per_page: pagination.per_page,
          total: pagination.total
        })
    }

    return state
  }
}

export default new AccommodationInvoicePaginationStore()
